import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {loadingWrap} from '../../rxjs/rx_loading';
import {RecruitService} from '../../services/recruit.service';
import {JobAdService} from '../../services/jobAd.service';
import {CommonService} from '../../services/common.service';
import {LoadingService} from '../../services/loading.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UserService} from '../../services/user.service';
import {Subscription} from 'rxjs';
import {City} from '../../models/city.model';
import {FieldWork} from '../../models/field-work.model';
import {User} from '../../models/user.model';
import {
    DEFAULT_DROPDOWN_CONFIG,
    ROLE
} from '../../const/mock-selectize-config';
import {Invoice} from '../../models/invoice.model';
import {ProfileEmployer} from '../../../features/my-account/models/profile-employer.moldel';
import {Country} from '../../models/country.model';
import {CountriesService} from '../../services/countries.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-checkout-form',
    templateUrl: './checkout-form.component.html',
})
export class CheckoutFormComponent implements OnInit {
    modalRef: BsModalRef = new BsModalRef();
    @Input() header: string;
    @Input() isCheckoutJob = false;
    @Output() isCheckout = new EventEmitter<any>();
    @Input() jobAd: any;
    cities: City[];
    countries: Country[];
    field_works: FieldWork[];
    user: User;
    subscription_3: Subscription;
    singleSelectConfig: any = Object.assign({}, DEFAULT_DROPDOWN_CONFIG, {
        labelField: 'city_name',
        valueField: 'city_name',
        searchField: ['city_name']
    });
    logoImg: File;
    reader = new FileReader();
    fileName: string;
    errors: any = {};
    userChecked = false;
    isLoggedIn = false;
    published?: boolean;

    userProfile: User = {};
    originalProfile: any;
    profile: any = {
      country: 'Sweden'
    };
    invoice: Invoice = {};
    arrSendInvoiceMethod: any = [];
    specificEmailEnable?: boolean;
    specificEmail: string;
    errorsCheckout: any = {};
    errorsUserInfo: any = {};
    expiry_date: any;
    isProlongAd: any;
    downloadGDPR?: string;
    currentLang?: string;
    constructor(private recruitService: RecruitService,
                private jobAdService: JobAdService,
                private commonService: CommonService,
                private loadingService: LoadingService,
                private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private modalService: BsModalService,
                private userService: UserService,
                private countriesService: CountriesService,
                private translateService: TranslateService,
                private toastrService: ToastrService) { }

    ngOnInit() {
      this.downloadGDPR = '/api/downloadGDPR';
      this.invoice.send_invoice_method = [];
        this.subscription_3 = this.authService.getAuth().subscribe((auth) => {
            this.isLoggedIn = auth.isLogIn;
            this.user = auth.user;
            this.userChecked = true;
        });
        this.userService.getUserProfile().pipe(loadingWrap()).subscribe(
            (data) => {
                this.userProfile = data['user'];
                this.originalProfile = data['profiles'];
                this.profile = this.getProfile(this.originalProfile);
                if (!this.profile.language) {
                  this.profile.language = this.userProfile.language;
                }
            }
        );
        if (this.jobAd) {
            const str = this.jobAd.new_expiry_date.toString();
            const index = str.indexOf('GMT');
            this.expiry_date = str.substr(0, index);
        }
        this.countriesService.findAll().pipe(loadingWrap()).subscribe(res => {
          this.countries = res;
        });
    }

    toggleSpecificEmail(event) {
        this.specificEmailEnable = event.target.checked;
    }

    updateProfile() {
        this.userService.updateUserProfile(this.profile, 'checkout').pipe(loadingWrap()).subscribe(() => {
            // Update profile
            this.userService.getUserProfile().pipe(loadingWrap()).subscribe(res => {
                    this.user = res['user'];
                    this.originalProfile = res['profiles'];
                    this.profile = this.getProfile(this.originalProfile);
                }
            );
            // Checkout
            this.checkoutJobAd();
            }, (errors) => {
                this.errorsUserInfo = errors.error.errors;
                this.toastrService.error(this.translateService.instant('checkoutJobAd.error.message'), this.translateService.instant('checkoutJobAd.title'), {progressBar: true});
            }
        );
    }
    updateProlongAd() {
        this.errorsCheckout = {};
        let hasError = false;

        if (!this.isProlongAd) {
            this.errorsCheckout.is_prolong_ad = ['checkout.validation.isProlongAd'];
            hasError = true;
        }
        if (this.arrSendInvoiceMethod.length === 0) {
            this.errorsCheckout.send_invoice_method = ['The send invoice method field is required.'];
            hasError = true;
        }
        if (hasError) {
            this.toastrService.warning(
                this.translateService.instant('checkout.validation.missingFields'),
                this.translateService.instant('checkoutProlongAd.title'),
                { progressBar: true }
            );
            return;
        }

        this.userService.updateUserProfile(this.profile, 'checkout').pipe(loadingWrap()).subscribe(
            (data) => {
                // Update profile
                this.userService.getUserProfile().pipe(loadingWrap()).subscribe(
                    (data) => {
                        this.user = data['user'];
                        this.originalProfile = data['profiles'];
                        this.profile = this.getProfile(this.originalProfile);
                    }
                );
                // Checkout
                this.checkoutProlongAd();
            }, (errors) => {
                this.errorsUserInfo = errors.error.errors;
                this.toastrService.error(this.translateService.instant('checkoutProlongAd.error.message'), this.translateService.instant('checkoutProlongAd.title'), {progressBar: true});
            }
        );
    }
    checkoutProlongAd() {
        this.checkInvoice();
        const formData = new FormData();
        formData.append('invoice', JSON.stringify(this.invoice));
        formData.append('isProlongAd', this.isProlongAd ? this.isProlongAd : null);
        formData.append('userProfile', JSON.stringify(this.profile));
        this.jobAdService.updateProlongAd(formData).pipe(loadingWrap()).subscribe(
            () => {
              this.toastrService.success(this.translateService.instant('checkoutProlongAd.success.message'), this.translateService.instant('checkoutProlongAd.title'), {progressBar: true});
              this.router.navigate(['/my-account/'], {queryParams: {tab: 'published'}});
            }, (errors) => {
                if (errors.status === 422) {
                  this.errorsCheckout = errors.error.errors;
                  this.toastrService.error(this.translateService.instant('checkoutProlongAd.error.message'), this.translateService.instant('checkoutProlongAd.title'), {progressBar: true});
                }
            }
        );
    }

    checkoutJobAd() {
        this.checkInvoice();
        const formData = new FormData();
        formData.append('invoice', JSON.stringify(this.invoice));
        formData.append('userProfile', JSON.stringify(this.profile));
        this.recruitService.checkoutJobAd(formData).pipe(loadingWrap()).subscribe(
            () => {
              this.toastrService.success(this.translateService.instant('checkoutJobAd.success.message'), this.translateService.instant('checkoutJobAd.title'), {progressBar: true});
                setTimeout(() => {
                  this.router.navigate(['/my-account/'], {queryParams: {tab: 'unPublished'}});
                  this.loadingService.hideLoading();
                }, 1000);
            }, (errors) => {
                if (errors.status === 422) {
                  this.errorsCheckout = errors.error.errors;
                  this.toastrService.error(this.translateService.instant('checkoutJobAd.error.message'), this.translateService.instant('checkoutJobAd.title'), {progressBar: true});
                }
            }
        );
    }
    checkInvoice() {
        if (this.specificEmailEnable) {
            this.invoice.invoice_email = this.specificEmail;
        } else {
            this.invoice.invoice_email = this.user.email;
        }
        this.invoice.job_ad_id = this.jobAd.id;
        this.invoice.user_id = this.jobAd.user_id;
    }
    getProfile(profile) {
        const profileEmployer = <ProfileEmployer>{};
        if (this.userService.checkRole(this.user.role) === ROLE.employer) {
            for (let item of profile) {
                switch (item.field_name) {
                    case 'firstName':
                        profileEmployer.firstName = item.value;
                        break;
                    case 'lastName':
                        profileEmployer.lastName = item.value;
                        break;
                    case 'companyName':
                        profileEmployer.companyName = item.value;
                        break;
                    case 'companyNum':
                        profileEmployer.companyNum = item.value;
                        break;
                    case 'address':
                        profileEmployer.address = item.value;
                        break;
                    case 'postCode':
                        profileEmployer.postCode = item.value;
                        break;
                  case 'country':
                        profileEmployer.country = item.value;
                        break;
                    case 'city':
                        profileEmployer.city = item.value;
                        break;
                    case 'phoneNumber1':
                        profileEmployer.phoneNumber1 = item.value;
                        break;
                    case 'phoneNumber2':
                        profileEmployer.phoneNumber2 = item.value;
                        break;
                    case 'language':
                        profileEmployer.language = item.value;
                        break;
                }
            }
            return profileEmployer;
        }
    }

    checkSendInvoiceMethod(value) {
        let arrSendInvoice = this.arrSendInvoiceMethod;
        let index = this.arrSendInvoiceMethod.indexOf(value);
        if (index === -1) {
            arrSendInvoice.push(value);
        } else {
            arrSendInvoice.splice(index, 1);
        }
        this.invoice.send_invoice_method = arrSendInvoice;
    }

  back(): void {
    this.isCheckout.emit(false);
  }
}
